import { render, staticRenderFns } from "./FAQDisplay.vue?vue&type=template&id=40214d5e&"
import script from "./FAQDisplay.vue?vue&type=script&lang=js&"
export * from "./FAQDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports